"use strict";
exports.AGENT_TYPES = Object.freeze({
    IN_HOUSE: 'in_house',
    GUARANTEED: 'guaranteed',
    FLEX: 'flex',
    UPANDUP_TEAM: 'upandup_team'
});
